<div class="page-container">
  <div class="flex items-center justify-between">
    <h1 class="main-heading">Car registration</h1>
    <app-navpath />
  </div>
  <section class="content-container">
    <app-data-form
      [dataFields]="carRegistration"
      [dataName]="'carRegistration'"
      (updateFields_child)="updateFields($event)"
      (clickSearch)="search($event)"
    />
  </section>
  <section class="content-container">
    <h2 class="sub-heading w-full">
      Factory standard equipment & items
    </h2>
    <p *ngIf="!lockDoc" class="text-xs text-red-400">
      Factory Standard Equipment & Items are auto-filled, click
      <strong>Update</strong>
      to save them
    </p>
    <div class="grid grid-cols-2">
      <div
        *ngFor="
          let item of equipmentItems;
          let index = index;
          trackBy: trackByIndex
        "
        class="bg-clear-50 hover:bg-clear-100 flex px-4 py-2 text-sm"
      >
        <p class="flex-1">{{ index + 1 }}.</p>
        <input
          type="text"
          [(ngModel)]="equipmentItems[index]"
          class="text-container flex-2"
        />
      </div>
    </div>
  </section>
  <section class="content-container">
    <h2 class="sub-heading w-full border-b">Vin series checking</h2>
    <app-data-form
      [dataFields]="vinSeriesChecking"
      [dataName]="'vinSeriesChecking'"
      (clickSearch)="searchvin($event)"
    />
    <div class="mt-4 flex w-fit gap-1">
      <button
        class="shorter-btn misc-btn"
        (click)="update()"
        [disabled]="lockDoc || lockUpdate"
      >
        <fa-icon [icon]="faSave" class="mr-1" />Update
      </button>
      <button class="shorter-btn clear-btn" (click)="clear()">
        <fa-icon [icon]="faBroom" class="mr-1" />Clear
      </button>
      <button class="shorter-btn misc-btn" (click)="print()">
        <fa-icon [icon]="faPrint" class="mr-1" />Print
      </button>
      <button
        class="shorter-btn misc-btn"
        [disabled]="lockDoc"
        (click)="updateFullDoc()"
      >
        <fa-icon [icon]="faSave" class="mr-1" />Full doc submitted
      </button>
    </div>
  </section>
</div>
